import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "M.851 8a7.333 7.333 0 1 1 14.667 0A7.333 7.333 0 0 1 .85 8m2.645-3.745A5.98 5.98 0 0 0 2.184 8c0 1.417.491 2.719 1.312 3.745l1.907-1.907A3.3 3.3 0 0 1 4.851 8c0-.68.203-1.311.552-1.838zm.943-.943L6.346 5.22a3.3 3.3 0 0 1 1.838-.552c.68 0 1.312.203 1.839.552l1.906-1.907A5.97 5.97 0 0 0 8.184 2 5.98 5.98 0 0 0 4.44 3.312M11.518 8c0-.68-.204-1.311-.553-1.838l1.907-1.907A5.98 5.98 0 0 1 14.184 8a5.98 5.98 0 0 1-1.312 3.745l-1.907-1.907A3.3 3.3 0 0 0 11.518 8m-3.334 6a5.98 5.98 0 0 1-3.745-1.312l1.907-1.907c.527.35 1.159.552 1.838.552.68 0 1.312-.203 1.839-.552l1.906 1.907A5.98 5.98 0 0 1 8.184 14m0-8a2 2 0 1 0 0 4 2 2 0 0 0 0-4",
        "clip-rule": "evenodd"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "currentColor",
          d: "M.19 0h16v16h-16z"
        })
      ])
    ], -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })